import { categories } from '@/mocks/categories';

const gridACategories = categories.slice(3, 6);

const gridAImages = [
  'https://readdy.ai/api/search-image?query=Lightweight%20sage%20green%20utility%20jacket%20hung%20on%20wooden%20hanger%20against%20warm%20ivory%20wall%2C%20soft%20studio%20lighting%20with%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20visible%20cotton%20canvas%20texture%2C%20muted%20earthy%20tones%20with%20olive%20and%20cream%20palette%2C%20clean%20minimalist%20composition&width=600&height=400&seq=grid-jackets-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20caramel%20toned%20wide%20leg%20linen%20trousers%20elegantly%20draped%20over%20wooden%20surface%2C%20soft%20natural%20window%20light%20creating%20flowing%20shadows%2C%20editorial%20fashion%20photography%20with%20visible%20fabric%20texture%2C%20warm%20earthy%20neutral%20palette%2C%20relaxed%20organic%20composition%20with%20gentle%20folds&width=600&height=400&seq=grid-pants-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Natural%20straw%20summer%20fedora%20hat%20placed%20on%20warm%20ivory%20linen%20surface%2C%20soft%20natural%20light%20casting%20gentle%20rim%20shadows%2C%20editorial%20product%20photography%20with%20visible%20woven%20texture%20detail%2C%20warm%20neutral%20palette%20with%20sandy%20tones%2C%20relaxed%20lifestyle%20composition&width=600&height=400&seq=grid-headwear-v2&orientation=landscape',
];

export default function CategoryCardGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-600 whitespace-nowrap">Curated Categories</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mt-3">
            More to Discover
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-md">
            Browse our handpicked fashion categories updated with the latest product collections.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gridACategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-background-300/80 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={gridAImages[idx]}
                  alt={`Superbuy Spreadsheet ${cat.name} fashion products`}
                  title={`Superbuy Spreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="font-heading text-lg font-semibold text-foreground-900">{cat.name}</h3>
                <div className="mt-3">
                  <span className={`inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${idx === 0 ? 'bg-primary-500 text-background-50 group-hover:bg-primary-600' : 'bg-background-50 text-foreground-700 border border-foreground-300/40 group-hover:border-foreground-400/60'}`}>
                    Shop Now
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </div>
                <p className="text-xs text-foreground-400 mt-2">Click to browse on kaspreadsheet.com</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}